import { render, staticRenderFns } from "./lkuItemLazzyRequest.vue?vue&type=template&id=7670e357"
import script from "./lkuItemLazzyRequest.vue?vue&type=script&lang=js"
export * from "./lkuItemLazzyRequest.vue?vue&type=script&lang=js"
import style0 from "./lkuItemLazzyRequest.vue?vue&type=style&index=0&id=7670e357&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports